/**
 * VowPath 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * VowPath 品牌特定主题配置
 */
export const theme = {
  // 头像边框色 (VowPath 使用 #FFF4ED)
  avatarBorder: '#FFF4ED',
  // 按钮背景色 (VowPath 使用 #FFF4ED)
  btnPrimaryBg: '#FFF4ED',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(90deg, #FFEFF6 0%, #E6E1FF 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/vowpath/member_subscribe_bg.webp)',
} as const

/**
 * VowPath 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/vowpath/member-bg.webp',
  // 用户背景图
  userBg: '/images/vowpath/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/vowpath/user-default.png',
  // VIP 图标
  memberVip: '/images/vowpath/member-vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/vowpath/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
